import React from 'react';
import { Handle, Position } from 'reactflow';
import NodeSymbolSelect from './NodeSymbolSelect';

export default function GapNode({ data = {}, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };
  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #0891b2',
      background: 'var(--card)',
      minWidth: 200,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#22d3ee' }}>
        ↕ Overnight Gap
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <div style={{ fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Outputs the gap %: today's open vs. the prior bar's close.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#0891b2' }} />
    </div>
  );
}
